import Image from "next/image";

export function PlatformVisual() {
  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200">
          {/* Using unifiedtime.png as a placeholder for the platform visual since it exists */}
          <div className="aspect-video relative bg-gray-100 flex items-center justify-center">
            <Image
              src="/unifiedtime.png"
              alt="Hub Dashboard Interface"
              width={1200}
              height={675}
              className="object-cover w-full h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
